import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { SessionService } from '../session/session.service';

export const errorHttpInterceptor: HttpInterceptorFn = (req, next) => {
    const _sessionService = inject(SessionService);

    return next(req).pipe(
        catchError(error => {
            if (error.status === 401) {
                _sessionService.logout();
            }

            return throwError(() => error);
        })
    );
};